import axios from "axios";

const clienteAxios = axios.create({
  baseURL: "https://suneita.herokuapp.com",
});

export default clienteAxios;
